<template>
  <el-dialog
    :title="$t('switchCompanyModal.title')"
    :visible.sync="visible"
    width="30%"
    @open="handleOpen"
    :before-close="handleClose">
    <el-row class="m-20">
      <span>{{$t('switchCompanyModal.instruction')}}</span>
    </el-row>
    <el-row>
      <el-select v-model="model.portausCompany" placeholder="Select" value-key="id">
        <el-option
          v-for="cie in portausCompanies"
          :key="cie.id"
          :label="cie.name"
          :value="cie">
        </el-option>
      </el-select>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="handleConfirm">
        <span v-if="!loading">{{$t('common.confirm')}}</span>
        <i class="el-icon-loading" v-if="loading"></i>
      </el-button>
    </span>
  </el-dialog>
</template>
<script>

import PortausCompanyAPI from '@/services/API/portaus-company'
import PortausUtils from '@/utils/portaus-utils'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'switch-portaus-company-modal',
  props: {
    visible: {
      type: Boolean,
    }
	},
	data() {
		return {
      portausCompanies : [],
      loading: false,
      model: {
        portausCompany: null,
      }
	   }
   },
  computed: {
    newCompanySelected () {
      return parseInt(this.$cookies.get('portaus-context-company')) !== this.model.portausCompany.id;
    },
    isAnonymousAuth(){
			return this.$store.getters.isAnonymousAuth;
		},
  },
  components : {
  },
  methods : {
    handleOpen () {
      this.loading = false;
      this.fetchPortausCompany();
    },
   handleClose () {
     this.loading = false;
     this.$emit('close');
   },
   handleConfirm () {
     if (this.newCompanySelected) {
      this.loading = true;
      PortausCompanyAPI.generateToken(this.model.portausCompany.id)
        .then((response) => {
          PortausUtils.changePortausContext(response.portausContextToken, this.model.portausCompany.id, this);
          this.AUTH_SET_PORTAUS_COMPANY(this.model.portausCompany);
          this.invalidateAdminUser();
          this.invalidateTaxes();
          this.invalidate();
          this.invalidateGLAccounts();
          this.invalidateCreditNoteType();
          this.invalidateRebateType();
          this.invalidateEmailCustomContent();
          this.invalidateInventories();
          this.$router.push('/dashboard');
          this.$router.go();
        }).catch((err) => {
          this.$message.error(this.$i18n.t('common.errors.generic'));
          this.loading = false;
        })
     }
   },
   fetchPortausCompany () {
     PortausCompanyAPI.getPortausCompany()
      .then((portausCompanies) => {
        this.portausCompanies = portausCompanies;
      })
   },
   ...mapActions(['AUTH_SET_PORTAUS_COMPANY']),
   ...mapActions('users', ['invalidateAdminUser']),
   ...mapActions('controlData', ['invalidateTaxes', 'invalidateGLAccounts', 'invalidateCreditNoteType', 'invalidateRebateType', 'invalidateEmailCustomContent', 'invalidateInventories']),
   ...mapActions('genericDashboards', ['invalidate'])
  },
  watch: {
    // deliveryType : function(newVal, oldVal){
    //   this.model.deliveryType = newVal
    // }
  },
  mounted(){
    this.model.portausCompany = {
      id: parseInt(this.$cookies.get('portaus-context-company'))
    };
  },
  created(){
    if (!this.isAnonymousAuth &&  _.get(localStorage.getItem('portaus-context')) != null) {
      this.fetchPortausCompany();
    } 
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

</style>
